
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { DeskMixin } from './mixin'

import HeaderView from '@/components/header/index.vue'
import PcBetView from '@/components/desk/betview/d-betview.vue'

import DPredictionSumaryView from '@/components/desk/prediction/d-prediction-sumary-view.vue'
import PcSwitchTable from '@/components/desk/switch-table/d-switch-table.vue'
import DGoodRoadPanel from '@/components/desk/good-road/d-good-road-panel.vue'
import DCardResultView from '@/components/desk/card-result/d-card-result-view.vue'
import CustomMoneyView from '@/components/dialogs/custom-money-dialog-view.vue'
import LimitDialogView from '@/components/dialogs/limit-dialog-view.vue'
import SettingView from '@/components/dialogs/setting-dialog-view.vue'
import ChangePasswordView from '@/components/dialogs/change-pass-view.vue'
import BetHistory from '@/components/dialogs/history-view.vue'
import PopAlertView from '@/components/desk/pop-alert.vue'
import router, { ROUTES } from '@/router'
import SvgMap from '@/components/roadmap/svg-map.vue'
import RuleView from '@/components/dialogs/rule-view.vue'

@Options({
    components: {
        HeaderView,
        DPredictionSumaryView,
        PcBetView,
        PcSwitchTable,
        DGoodRoadPanel,
        DCardResultView,
        CustomMoneyView,
        LimitDialogView,
        SettingView,
        ChangePasswordView,
        BetHistory,
        PopAlertView,
        'svg-map': SvgMap,
        'rule-view': RuleView
    }
})
export default class PcDesk extends Mixins(DeskMixin) {}
